import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CONTACT_EMAIL } from '../utils/contact';
import './Legal.css';

const PRIVACY_EMAIL = 'privacidade@libbenincorp.com';

// Layout compartilhado das paginas legais. Recebe titulo, data, as secoes e
// um e-mail de contato opcional.
export default function LegalLayout({ title, canonical, metaDescription, updatedAt, sections, contactEmail }) {
  const email = contactEmail || PRIVACY_EMAIL;
  return (
    <div className="legal-page">
      <Helmet>
        <title>{title} — LibbenIncorp</title>
        {metaDescription && <meta name="description" content={metaDescription} />}
        {canonical && <link rel="canonical" href={canonical} />}
      </Helmet>

      <div className="legal-glow" />
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">{title}</h1>
          <div className="legal-meta">
            <span className="legal-badge">Versao 1.0</span>
            <span className="legal-date">Ultima atualizacao: {updatedAt}</span>
          </div>
        </div>

        <div className="legal-sections">
          {sections.map((section, i) => (
            <div key={i} className="legal-section">
              <h2 className="legal-section-title">{section.title}</h2>
              <p className="legal-section-text">{section.content}</p>
            </div>
          ))}
        </div>

        <div className="legal-contact">
          <h3 className="legal-contact-title">Contato</h3>
          <a href={`mailto:${email}`} className="legal-contact-item">
            <span>E-mail:</span>
            <strong>{email}</strong>
          </a>
        </div>

        <p className="legal-footer">
          © 2026 LibbenIncorp. Todos os direitos reservados. Duvidas comerciais: {CONTACT_EMAIL}.
        </p>
      </div>
    </div>
  );
}
